import { useApiQualityReportV1SiteMaterialExistsRetrieve } from 'api';
import { useTranslation } from 'i18n';
import { Button, Tooltip } from 'ui';

export const getTooltipTitle = (isEnoughEvidence: boolean, isSiteMaterialIdPresent: boolean) => {
  if (!isSiteMaterialIdPresent) {
    return 'qualityReport.link.tooltip.noMaterialSelected';
  }
  if (!isEnoughEvidence) {
    return 'qualityReport.link.tooltip.notEnoughEvidence';
  }
  return '';
};

export const QualityReportLink = ({
  siteMaterialPublicId,
  disabled,
  fullWidth = true,
  size,
  tradeCompanyId,
}: {
  siteMaterialPublicId?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  tradeCompanyId?: number;
}) => {
  const { t } = useTranslation('features');
  const isSiteMaterialIdPresent = Boolean(siteMaterialPublicId);

  const { isError, isSuccess, isLoading } = useApiQualityReportV1SiteMaterialExistsRetrieve(
    siteMaterialPublicId || '',
    {
      query: { enabled: isSiteMaterialIdPresent, retry: false },
    }
  );

  const URL = tradeCompanyId
    ? `/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/${siteMaterialPublicId}/report/`
    : `/report/${siteMaterialPublicId}/`;
  const tooltipTitleKey = getTooltipTitle(isSuccess, isSiteMaterialIdPresent);

  return (
    <Tooltip title={tooltipTitleKey ? t(tooltipTitleKey) : ''}>
      <Button
        fullWidth={fullWidth}
        data-testid="quality-report-link"
        variant="secondary"
        size={size}
        component="a"
        href={URL}
        target="_blank"
        loading={isLoading}
        disabled={disabled || isError}
      >
        {t('qualityReport.link.buttonLabel')}
      </Button>
    </Tooltip>
  );
};
